// DeviceCard — 附近设备卡片
// 复刻 LocalSend peer_device_card.dart：设备图标 + 别名 + 设备类型 + 发送按钮

import type { ClientInfo } from '@kuaichuan/shared';
import { deviceIcon, deviceTypeLabel } from '../../lib/ui/deviceIcons';

interface DeviceCardProps {
  peer: ClientInfo;
  onSend: () => void;
  disabled?: boolean;
}

export function DeviceCard({ peer, onSend, disabled }: DeviceCardProps) {
  return (
    <button
      type="button"
      onClick={onSend}
      disabled={disabled}
      className="card p-4 flex flex-col items-center gap-2 hover:border-primary hover:shadow-pop transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <div className="w-14 h-14 rounded-full bg-primary-50 flex items-center justify-center text-3xl">
        {deviceIcon(peer.deviceType)}
      </div>
      <div className="text-center w-full">
        <div className="font-medium text-ink truncate" title={peer.alias}>
          {peer.alias}
        </div>
        <div className="text-xs text-muted">{deviceTypeLabel(peer.deviceType)}</div>
      </div>
      <span className="mt-1 text-xs text-primary font-medium">📡 发送</span>
    </button>
  );
}
